import StyledButton  from "./StyledButton";  

export default StyledButton;
